module.exports = "/_next/static/images/game-1-phone-uv-clock-2c64d755871353249d2fff9041abdc5c.png";